function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import CheckboxGroup from './checkbox-group';
import { checkboxGroupPropTypes, DropdownSelect, fieldOptionsType } from '../helpers';
import { InputLabel } from '../labels';

/**
 *
 * A group of checkboxes that can be used in a `redux-form`-controlled form.
 * Wraps the {@link CheckboxGroup} component in a {@link DropdownSelect} component, which displays the selected values as a list.
 * Options are displayed in a scrollable `Select`-style dropdown container.
 *
 * The value of each checkbox is specified via the `options` prop. This prop can either be:
 * - An array of strings
 * - An array of key-value pairs: `{ key, value }`
 *
 * The value of the entire `DropdownCheckboxGroup` component is an **array** containing the values of the selected checkboxes.
 * Clicking an unselected checkbox adds its value to this array, and clicking a selected checkbox removes its value from this array.
 *
 * @name DropdownCheckboxGroup
 * @type Function
 * @param {Object} input - A `redux-form` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object
 * @param {Object} meta - A `redux-form` [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) object
 * @param {Array} options - An array of checkbox values (strings or key-value pairs)
 * @example
 *
 * function InterestsForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field
 *          name="interests"
 *          component={ DropdownCheckboxGroup }
 *          options={[
 *            'Art',
 *            'Computer Science',
 *            'Dance'
 *          ]}
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 *
 * export default TodoForm
 */

var propTypes = _objectSpread(_objectSpread({}, checkboxGroupPropTypes), {}, {
  options: fieldOptionsType
});
function DropdownCheckboxGroup(props) {
  var _props$input = props.input,
    name = _props$input.name,
    value = _props$input.value,
    label = props.label;
  return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(InputLabel, {
    label: label,
    name: name
  }), /*#__PURE__*/React.createElement(DropdownSelect, {
    selectedValues: value,
    className: "checkboxes"
  }, /*#__PURE__*/React.createElement(CheckboxGroup, _extends({}, props, {
    label: false
  }))));
}
DropdownCheckboxGroup.propTypes = propTypes;
export default DropdownCheckboxGroup;